var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SelectPicker',_vm._b({staticClass:"special-features",attrs:{"options":_vm.options,"multiple":_vm.multiple !== false},on:{"selected":_vm.transmit,"removed":_vm.transmit},model:{value:(_vm.local_value),callback:function ($$v) {_vm.local_value=$$v},expression:"local_value"}},'SelectPicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }